export default "__VITE_ASSET__GQOBZfRf__"